
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/[...slugs]",
      function () {
        return require("private-next-pages/articles/[...slugs].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/[...slugs]"])
      });
    }
  